import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const reviewService = {
  /**
   * Get review badge for a single product
   */
  async getReviewBadge(productId) {
    try {
      const response = await axios.get(`${API}/api/reviews/badge/${productId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching review badge:', error);
      return { rating: 0, reviewCount: 0, hasReviews: false };
    }
  },

  /**
   * Get review badges for multiple products
   */
  async getReviewBadges(productIds) {
    try {
      const ids = productIds.join(',');
      const response = await axios.get(`${API}/api/reviews/badges`, {
        params: { product_ids: ids }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching review badges:', error);
      return {};
    }
  },

  /**
   * Get actual reviews for a product
   */
  async getProductReviews(productId, page = 1, perPage = 5) {
    try {
      const response = await axios.get(`${API}/api/reviews/product/${productId}`, {
        params: { page, per_page: perPage }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching product reviews:', error);
      return { reviews: [], totalReviews: 0 };
    }
  }
};

export default reviewService;
